import React from 'react';

type FormCheckboxProps = {
    label: string;
    name: string;
    checked?: boolean;
    onChange?: (checked: boolean) => void;
    disabled?: boolean;
};

const FormCheckbox = ({ label, name, checked = false, onChange, disabled }: FormCheckboxProps) => {
    return (
        <div className="mb-4">
            <label
                htmlFor={name}
                className="inline-flex items-center gap-2 cursor-pointer select-none"
            >
                <input
                    id={name}
                    name={name}
                    type="checkbox"
                    checked={checked}
                    onChange={(e) => onChange?.(e.target.checked)}
                    disabled={disabled}
                    className="w-4 h-4 rounded"
                    style={{ accentColor: 'var(--accent)' }}
                />
                <span className="text-sm" style={{ color: 'var(--text-primary)' }}>
                    {label}
                </span>
            </label>
        </div>
    );
};

export default FormCheckbox;
